import {
  activateBomApi,
  createBomApi,
  createHardwareLineApi,
  createPackagingLineApi,
  createPackagingOptionApi,
  createWoodLineApi,
  deleteHardwareLineApi,
  deletePackagingLineApi,
  deletePackagingOptionApi,
  deleteWoodLineApi,
  getBomApi,
  getBomFamilyVersionsApi,
  listBomsApi,
  patchBomHeaderApi,
  saveActiveBomApi,
  updateHardwareLineApi,
  updatePackagingLineApi,
  updatePackagingOptionApi,
  updateWoodLineApi,
  cloneBomApi,
  compareBomsApi,
  BomsApiClientError,
  type CloneBomInput,
  type BomCompareResult,
} from './apiClient'
import type {
  Bom,
  BomCreateInput,
  BomDetail,
  BomHeaderPatchInput,
  BomStatus,
} from './types'

export const bomService = {
  list(filter?: {
    status?: BomStatus
    product_id?: string
    q?: string
  }): Promise<Bom[]> {
    return listBomsApi(filter)
  },
  getById(id: string): Promise<BomDetail | null> {
    return getBomApi(id)
  },
  create(input: BomCreateInput): Promise<BomDetail> {
    return createBomApi(input)
  },
  clone(id: string, input?: CloneBomInput): Promise<BomDetail> {
    return cloneBomApi(id, input)
  },
  compare(baseId: string, targetId: string): Promise<BomCompareResult> {
    return compareBomsApi(baseId, targetId)
  },
  patchHeader(id: string, patch: BomHeaderPatchInput): Promise<Bom> {
    return patchBomHeaderApi(id, patch)
  },
  activate(id: string): Promise<BomDetail> {
    return activateBomApi(id)
  },
  saveActive: saveActiveBomApi,
  getFamilyVersions: getBomFamilyVersionsApi,
  createWoodLine: createWoodLineApi,
  updateWoodLine: updateWoodLineApi,
  deleteWoodLine: deleteWoodLineApi,
  createPackagingOption: createPackagingOptionApi,
  updatePackagingOption: updatePackagingOptionApi,
  deletePackagingOption: deletePackagingOptionApi,
  createHardwareLine: createHardwareLineApi,
  updateHardwareLine: updateHardwareLineApi,
  deleteHardwareLine: deleteHardwareLineApi,
  createPackagingLine: createPackagingLineApi,
  updatePackagingLine: updatePackagingLineApi,
  deletePackagingLine: deletePackagingLineApi,
}

export type {
  Bom,
  BomCreateInput,
  BomDetail,
  BomHardwareLine,
  BomHeaderPatchInput,
  BomPackagingLine,
  BomPackagingOption,
  BomStatus,
  BomWoodLine,
  AssemblyType,
  IstaLevel,
} from './types'
export { BOM_STATUS_LABEL } from './types'
export {
  BomsApiClientError,
  saveActiveBomApi,
  getBomFamilyVersionsApi,
  cloneBomApi,
  compareBomsApi,
}
export type {
  SaveActiveBomInput,
  CloneBomInput,
  BomCompareResult,
  BomCompareLineDiff,
} from './apiClient'

